// theirs
import React from 'react'
import styled from 'styled-components'
import InView, { IntersectionOptions } from 'react-intersection-observer'
// ours
import { CollectionContext, CollectionContextInterface } from '../../App'
import { InViewIcon } from '../../utils/InViewIcon'
import { ContentDataModel } from '../../interfaces'
import Content from '../Content'

interface FrameProps {
    className?: string
    testId?: string
    collectionContext?: CollectionContextInterface
    inViewOptions?: IntersectionOptions
    content: ContentDataModel
    customFrameHeight?: number
}

const StyledFrame = styled.div<FrameProps>`
    height: ${(props) => props.customFrameHeight}px;
    width: ${(props) => props.collectionContext?.dimensions.width}px;
    padding: 0;
    margin: 0;
    position: relative;
`

const Frame = ({ className, testId, inViewOptions, content }: FrameProps) => {
    const collectionContext = React.useContext(CollectionContext)
    inViewOptions = {
        threshold: content.contentCanvasType === undefined ? 0.30:0.0001,
        delay: inViewOptions?.delay ? inViewOptions.delay : 100,
        trackVisibility: true,
    }
    const frameHeight =
        collectionContext?.dimensions.height !== undefined
            ? collectionContext.dimensions.height
            : 0
    const customFrameHeight =
        typeof content.contentNextChapter === 'object'
            ? frameHeight * 2
            : frameHeight
    return (
        <InView threshold={inViewOptions.threshold} delay={inViewOptions.delay}>
            {({ ref, inView }) => (
                <StyledFrame
                    ref={ref}
                    className={className}
                    data-testid={testId}
                    collectionContext={collectionContext || undefined}
                    content={content}
                    customFrameHeight={customFrameHeight}
                >
                    <InViewIcon inView={inView} content={content} />
                    <Content inView={inView} content={content} />
                </StyledFrame>
            )}
        </InView>
    )
}

export default Frame
